import * as Yup from "yup";

/* eslint-disable no-invalid-this */

const hasFilledQuantity = (value) => {
  if (value === "" || value === null || value === undefined) return false;
  const n = Number(value);
  return Number.isFinite(n) && n >= 1;
};

/** Each row in the array was explicitly added — requirement name and quantity are required. */
export const logisticsRequirementRowSchema = (messages, requirementCatalog = []) =>
  Yup.object().shape({
    requirement_id: Yup.mixed().test(
      "requirement-ref",
      messages.required,
      function requirementRef(value) {
        const hasId =
          value !== "" && value !== null && value !== undefined;
        if (hasId) return true;
        const nm = String(this.parent?.name ?? "").trim().toLowerCase();
        if (!nm || !requirementCatalog.length) return false;
        return requirementCatalog.some(
          (opt) =>
            String(opt?.name ?? "").trim().toLowerCase() === nm,
        );
      },
    ),
    name: Yup.string().trim().nullable(),
    quantity: Yup.mixed().test(
      "qty-non-empty",
      messages.required,
      (value) => hasFilledQuantity(value),
    ),
    notes: Yup.string().max(100, messages.maxHundredChars).nullable(),
  });

const portalZonesShape = (messages) =>
  Yup.object().shape({
    zones_attributes: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .trim()
            .required(messages.required)
            .max(50, messages.maxFiftyChars),
          supervisor_id: Yup.mixed().nullable(),
        }),
      )
      .min(1, messages.zoneRequired),
  });

/** Draft save — zones only; logistics rows stay optional; zone map optional. */
export const getPortalZonesStepDraftValidationSchema = (messages) =>
  portalZonesShape(messages).concat(
    Yup.object().shape({
      zones_image_url: Yup.mixed().nullable().notRequired(),
    }),
  );

/**
 * Continue / Finish — logistics rows map to `event_requirements_attributes`
 * (`requirement_id`, `quantity`, `explanation` per PROLINE-2274 §2.5).
 * Either pick `requirement_id` from UISelect or match free-text `name` to lookup catalog.
 * The section is optional; filled rows are validated individually.
 */
export const getPortalZonesStepFullValidationSchema = (
  messages,
  requirementCatalog = [],
) =>
  Yup.object().shape({
    ...portalZonesShape(messages).fields,
    logistics_requirements_attributes: Yup.array().of(
      logisticsRequirementRowSchema(messages, requirementCatalog),
    ),
    zones_image_url: Yup.mixed().test(
      "zones-map-required",
      messages.zoneMapRequired,
      (value) =>
        value instanceof File ||
        (typeof value === "string" && String(value).trim() !== ""),
    ),
  });
